// Shared password rule set so any form asking for a new password (registration,
// reset password, etc.) can render the same checklist and validate consistently.
export const PASSWORD_RULES = [
  { key: "minLength", label: "At least 8 characters" },
  { key: "uppercase", label: "Uppercase letter" },
  { key: "lowercase", label: "Lowercase letter" },
  { key: "number", label: "Number" },
  { key: "specialChar", label: "Special character" },
];

export const getPasswordChecks = (password = "") => ({
  minLength: password.length >= 8,
  uppercase: /[A-Z]/.test(password),
  lowercase: /[a-z]/.test(password),
  number: /[0-9]/.test(password),
  specialChar: /[^A-Za-z0-9]/.test(password),
});

export const isPasswordValid = (password = "") =>
  Object.values(getPasswordChecks(password)).every(Boolean);
